import React, { useEffect, useState } from "react";
import '../../styles/CourseDetail002.css'
import { Link, useParams, useNavigate } from "react-router-dom";
import coursesData from "../../data/CourseData";
import InscriptionModal from "../modals/InscriptionModal";
import WhatsAppButton from "../header/WhatsAppButton";
import Accordion from "../pages/Accordion";
import logogarantia from "../../assets/img/sello_garantia.webp";
import { getLocation } from "../utils/GetLocation";
import { trackMetaEvent } from '../utils/MetaPixel';
import { CountdownTimer } from '../utils/CountdownTimer';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import testimonio1 from "../../assets/img/testimonioIntrodProg1.webp";
import testimonio2 from "../../assets/img/testimonioIntrodProg2.webp";
import testimonio3 from "../../assets/img/testimonioIntrodProg3.webp";
import testimonio4 from "../../assets/img/testimonioIntrodProg4.webp";
import testimonio5 from "../../assets/img/testimonioIntrodProg5.webp";
import testimonio6 from "../../assets/img/testimonioIntrodProg6.webp";
import imgHeader from "../../assets/img/page-header.webp";
import imgWhatsApp from "../../assets/img/whatsApp.svg";
import PresalePrices from "../utils/PresalePrices";
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const CourseDetail = () => {
  const { id } = useParams();
  // Buscar el curso por ID en la lista de cursos
  const course = coursesData.find(course => course.id === id);

  const phoneNumber = "573014953565";
  const message = encodeURIComponent(
    `Quiero inscribirme en el curso de "${course.titleMain}" con la promoción de la página web pero aún tengo dudas y quisiera resolverlas`
  );
  const whatsappUrl = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${message}`;

  const [showModal, setShowModal] = useState(false); // Estado del modal
  const [price, setPrice] = useState({ oldPrice: "No Disponible", newPrice: "No Disponible", priceInscription: "No Disponible" });
  const [presalePrices, setPresalePrices] = useState({});
  const [country, setCountry] = useState('');

  const benefits = [
    { title: "Clases Prácticas Grabadas", description: "Aprende a importar desde la plataforma 1688.com, más barata que Temu y Alibaba con clases grabadas paso a paso." },
    { title: "Evita Estafas y Detecta Buen Proveedores", description: "Identifica proveedores confiables y evita errores comunes que te pueden hacer perder dinero." },
    { title: "Importa con Poco Dinero y Sin Experiencia", description: "Comienza a importar sin tener conocimientos previos ni grandes inversiones." },
    { title: "Acompañamiento Personalizado", description: "Recibe soporte directo por WhatsApp para resolver tus dudas reales durante el curso." },
    { title: "Calcula tus Costos y Rentabilidad", description: "Aprende a estimar impuestos, costos de envío y márgenes de ganancia usando nuestras plantillas." },
    { title: "Ideal para tu Tienda Online o Negocio Físico", description: "Lanza tu emprendimiento desde cero con productos importados de China y guía paso a paso." }
  ];

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);

  let countryValues = 'us';

  //Mover el scroll al inicio cuando se carga la página
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    getLocation().then(({ countryCode }) => {
      const resolvedCountry = countryCode || 'us';
      setCountry(resolvedCountry);
      countryValues = course.values[countryCode] || course.values["us"]; // Si el país no está definido, usa USD
      setPrice({ oldPrice: countryValues.oldPrice.toLocaleString("de-DE"), newPrice: countryValues.newPrice.toLocaleString("de-DE"), priceInscription: ((countryValues.newPrice) * 0.6).toLocaleString("de-DE"), currency: countryValues.currency, priceFormat: countryValues.newPrice });
      setPresalePrices(countryValues?.presale)
    });
  }, [course.values]);

  useEffect(() => {
    if (course) {
      // 🔹 Enviar evento de "ViewContent" cuando alguien entra a la página del curso
      trackMetaEvent('ViewContent', {
        content_name: course.title,
        content_category: 'Curso Online',
        content_ids: [course.id]
      });
    }
  }, [course]);

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 4000
  };

  const navigate = useNavigate();

  // Si no se encuentra el curso, mostrar mensaje de "En desarrollo"
  if (!course.active) {
    return (
      <>
        {/* Header Section */}
        <div className="w-100 overflow-hidden mb-5 position-relative" style={{ minHeight: '300px' }}>
          <img
            src={imgHeader}
            alt="Encabezado de página curso online"
            className="position-absolute top-0 start-0 w-100 h-100 object-fit-cover"
            style={{ zIndex: 0 }}
            loading="eager"
            decoding="async"
            fetchpriority="high"
          />

          <div className="position-absolute top-0 start-0 w-100 h-100" style={{ background: 'rgba(0, 0, 0, 0.5)', zIndex: 1 }}></div>

          <div className="container position-relative" style={{ zIndex: 2 }}>
            <div className="d-flex flex-column justify-content-center h-100" style={{ minHeight: '300px' }}>
              <h3 className="display-4 text-white text-uppercase">Detalles del curso</h3>
              <div className="d-inline-flex text-white">
                <p className="m-0 text-uppercase">
                  <Link to="/">Inicio</Link>
                </p>
                <i className="fa fa-angle-double-right pt-1 px-3"></i>
                <p className="m-0 text-uppercase">Detalles del curso</p>
              </div>
            </div>
          </div>
        </div>
        <div className="container py-5 text-center">
          <h2 style={{ backgroundColor: "red", color: "white" }}>El curso aún no está disponible, pero muy pronto abriremos inscripciones. 🎉</h2>
          <h3 className="text-center mt-4">Atento al lanzamiento los próximos días para obtener el precio de PREVENTA.</h3>
        </div>
        <div className="text-center">
          <button onClick={() => navigate("/")} className="px-4 py-2 btn-primary">
            IR A LA PÁGINA PRINCIPAL
          </button>
        </div>
      </>
    );
  }

  return (
    <div id="import-course-lp" style={{ fontFamily: 'Poppins, sans-serif', backgroundColor: '#0f172a', color: '#fff' }}>
      <div className="top-banner">
        <div className="scrolling-text">
          {course.hookMain}
        </div>
      </div>
      {/* HERO */}
      <section className="hero-bg relative min-h-screen flex items-center justify-center overflow-hidden px-4 pt-20 pb-10 sm:pt-24 sm:pb-12">
        {/* Efecto de resplandor de fondo */}
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2">
          <div className="w-[400px] h-[400px] sm:w-[800px] sm:h-[800px] bg-orange-500/10 rounded-full blur-3xl"></div>
        </div>

        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <h1 className="text-4xl sm:text-5xl md:text-7xl font-extrabold tracking-tighter mb-4">
            <div className="text-center"><h3>
              {course.hook.map((part, index) => (
                <span key={index} style={part.style}>
                  {part.text}{" "}
                </span>
              ))}</h3>
            </div>
          </h1>
          <p className="text-lg md:text-xl text-gray-300 max-w-2xl mx-auto mb-8">
            {course.subtitle}
          </p>
          <div style={{ fontSize: "30px", fontWeight: 'bold' }}>Curso {course.titleMain}</div>
          <div class="flex flex-col sm:flex-row gap-4 justify-center">
            <a href="#pricing" class="brand-gradient text-black font-bold py-4 px-8 rounded-lg text-lg shadow-lg shadow-yellow-500/20 hover:scale-105 transform transition-all duration-300 ease-in-out" onClick={() => trackMetaEvent('Lead', { content_name: course.title })}>
              ¡QUIERO INSCRIBIRME AHORA!
            </a>
          </div>
          <p className="mt-4 text-sm text-gray-400">Acceso de por vida y a todas las actualizaciones.</p>
        </div>
      </section>

      {/* PROBLEMAS */}
      <section className="py-16 sm:py-24 bg-black/20">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-4">¿Cansado de los altos costos y la incertidumbre?</h2>
            <p className="text-lg text-gray-400 max-w-3xl mx-auto">
              Dejar de depender de proveedores locales con precios inflados es posible. La clave está en llegar a la fuente.
            </p>
          </div>
          <div className="mt-12 grid md:grid-cols-2 gap-8 items-center">
            <div className="space-y-6">
              {/* Problemas comunes */}
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 brand-gradient rounded-full flex items-center justify-center text-black font-bold text-xl">X</div>
                <div>
                  <h3 className="text-xl font-semibold">Precios Elevados</h3>
                  <p className="text-gray-400 mt-1">Comprar localmente significa pagar márgenes de ganancia de múltiples intermediarios.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 brand-gradient rounded-full flex items-center justify-center text-black font-bold text-xl">X</div>
                <div>
                  <h3 className="text-xl font-semibold">Miedo a Estafas</h3>
                  <p className="text-gray-400 mt-1">El temor a perder tu inversión por no conocer el proceso correcto te paraliza.</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 brand-gradient rounded-full flex items-center justify-center text-black font-bold text-xl">X</div>
                <div>
                  <h3 className="text-xl font-semibold">Procesos Complicados</h3>
                  <p className="text-gray-400 mt-1">La logística, los envíos y la aduana parecen un laberinto imposible de navegar.</p>
                </div>
              </div>
            </div>
            {/* La solución */}
            <div className="p-8 bg-gray-800/50 rounded-2xl border border-gray-700">
              <h3 className="text-2xl font-bold brand-gradient-text mb-4">La Solución: Curso "{course.titleMain}"</h3>
              <p className="text-gray-300 text-lg mb-4">
                Te entregamos el <span className="font-bold text-yellow-400">mapa exacto y probado</span> para que compres como los grandes, directamente en el mercado más grande de China, de forma segura y maximizando tu rentabilidad desde la primera importación.
              </p>
              <img src="https://images.pexels.com/photos/187041/pexels-photo-187041.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1" alt="Imagen de un contenedor de carga" className="rounded-lg object-cover w-full h-48 mt-4 shadow-lg" />
            </div>
          </div>
        </div>
      </section>

      {/* BENEFICIOS */}
      <section id="benefits" className="py-16 sm:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">¿Qué Lograrás con este Curso?</h2>
            <p className="mt-3 text-lg text-gray-400">Transforma tu manera de hacer negocios con habilidades prácticas y rentables.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
            {benefits.map((benefit, index) => (
              <div key={index} className="bg-gray-800/50 p-6 rounded-2xl border border-gray-700 transform hover:-translate-y-2 transition-transform duration-300">
                <h3 className="text-xl font-bold text-yellow-400 mb-2 text-center">{benefit.title}</h3>
                <p className="text-gray-300">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
        <br></br>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <a href="#pricing" className="brand-gradient text-black text-center font-bold py-4 px-8 rounded-lg text-lg shadow-lg shadow-yellow-500/20 hover:scale-105 transform transition-all duration-300 ease-in-out" onClick={() => trackMetaEvent('Lead', { content_name: course.title })}>
            {course.botonHookText}
          </a>
        </div>
        <div className="flex justify-center py-16 sm:py-24 bg-black/20">
          <img
            src={course.imgBonus}
            alt="Beneficios Curso Online"
            className="w-full max-w-3xl h-auto"
          />
        </div>
      </section>

      {/* PLAN DE ESTUDIO */}
      <section id="content" className="py-16 sm:py-24 bg-black/20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-12">
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Contenido del Curso</h2>
            <p className="mt-3 text-lg text-gray-400">Tu ruta de aprendizaje paso a paso hacia el éxito.</p>
          </div>
          <Accordion course={course} />
        </div>
      </section>

      {/* INSTRUCTOR */}
      <section id="mentor" className="py-16 sm:py-24">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="text-center md:text-left">
              <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Conoce a tu Mentor</h2>
              <h3 className="mt-2 text-2xl sm:text-3xl font-bold brand-gradient-text">{course.instructor.name}</h3>
              <p className="mt-4 text-lg text-gray-300">
                {course.instructor.bio}
              </p>
            </div>
            <div>
              <img src={course.instructor.image} alt={course.instructor.name} className="rounded-full mx-auto md:mx-0 shadow-2xl shadow-yellow-500/10 w-64 h-64 md:w-80 md:h-80 object-cover border-4 border-yellow-400" />
            </div>
          </div>
        </div>
      </section>


      {/* TESTIMONIOS */}
      {course.id === "1" && (
        <section className="content-wrapper" style={{ backgroundColor: '#0f172a', padding: '3rem 1rem', textAlign: 'center' }}>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>💬 LO QUE DICEN NUESTROS ESTUDIANTES</h2>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            <Slider {...sliderSettings}>
              <div>
                <img src={testimonio1} alt="Estudiante 1" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio2} alt="Estudiante 2" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio3} alt="Estudiante 3" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio4} alt="Estudiante 4" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio5} alt="Estudiante 5" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
              <div>
                <img src={testimonio6} alt="Estudiante 5" style={{ borderRadius: '10px', width: '100%' }} />
              </div>
            </Slider>
          </div>
        </section>
      )}

      {/* PRECIOS Y PROMOCIONES */}
      {course?.presale && !(countryValues?.presale) && (<div className="p-8">
        <PresalePrices values={presalePrices} currency={price.currency} />
      </div>)}
      <h1 className="animated-text">¡ESTAS A UN PASO DE CAMBIAR TU FUTURO CON ESTE CURSO!</h1>
      <br></br>
      <section id="pricing" className="py-16 sm:py-24 bg-black/20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight">Accede a Todo Este Conocimiento Hoy</h2>
          <p className="mt-3 text-lg text-gray-400">Una inversión única para un retorno de por vida.</p>
                <div className="text-slate-600 text-lg mb-4" style={{ fontSize: "15px", color: "red", fontWeight: "bold" }}>¡SI ESTAS CON VPN DESCONECTATE PARA VER PRECIOS DE TU PAIS!</div>


          <div className="mt-12 max-w-lg mx-auto bg-gray-800/50 rounded-2xl border border-yellow-400 shadow-2xl shadow-yellow-500/10 p-8">
            <h3 className="text-2xl font-bold">{course.titleMain}</h3>
            <p className="text-3xl text-slate-500 line-through" style={{ color: 'red' }}>
                    Antes: {price.oldPrice} {price.currency}
            </p>
            <p className="mt-4 text-gray-300">
              <span className="text-5xl sm:text-6xl font-extrabold brand-gradient-text">{price.newPrice}</span>
              <span className="text-xl font-medium text-gray-400">{price.currency}</span>
            </p>
            <p className="mt-2 text-gray-400">
              <span className="ml-2 font-bold text-yellow-400">¡ESTÁS AHORRANDO: {
                (() => {
                  const cleanOld = parseFloat(price.oldPrice.replace(/\./g, "").replace(/,/g, "."));
                  const cleanNew = parseFloat(price.newPrice.replace(/\./g, "").replace(/,/g, "."));
                  const ahorro = cleanOld - cleanNew;

                  return ahorro >= 1000
                    ? Math.round(ahorro).toLocaleString()
                    : Math.round(ahorro).toString();
                })()
              } {price.currency} POR TIEMPO LIMITADO!</span>
            </p>
            <ul className="mt-8 text-left space-y-3 text-gray-300">
              {course.includedCourse.map((item, index) => (
                <li key={index} className="flex items-center gap-3"><svg className="w-6 h-6 text-green-400 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd"></path></svg> {item}</li>
              ))}
            </ul>


            <button className="animated-buy-button" onClick={() => {
              handleShowModal();
              trackMetaEvent('InitiateCheckout', { content_name: course.title, content_ids: [course.id], currency: price.currency, value: price.newPrice })
            }
            }>COMPRAR EL CURSO AHORA</button>
            <div className="mt-4 flex items-center justify-center gap-2">
              <svg className="w-5 h-5 text-gray-400" fill="currentColor" viewBox="0 0 20 20"><path fillRule="evenodd" d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z" clipRule="evenodd"></path></svg>
              <span className="text-sm text-gray-400">Pago 100% seguro desde cualquier país</span>
            </div>
          </div>
          <br></br>
          <h4 className="text-center" style={{ color: "white" }}>Fecha de inicio: {course.startDate}</h4>
        </div>

      </section>

      {/* TIMER */}
      {course?.emergencyStopwatch && (
        <section className="content-wrapper" style={{ backgroundColor: '#1e293b', textAlign: 'center' }}>
          <CountdownTimer />
        </section>)}

      {/* GARANTÍA */}
      <section className="content-wrapper" style={{ background: '#0f172a', padding: '2rem 1rem', textAlign: 'center' }}>
        <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', color: 'white' }}>🎯 GARANTÍA DE EXCELENCIA</h2>
        <div className="garantia-container">
          <div className="garantia-text">
            <h4 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              Con nuestro curso y el Sello de Excelencia de 5 Días, no solo aprenderás, sino con total confianza.
            </h4>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              💡 Si en los primeros 5 días te arrepientes de tu compra, te devolvemos el 80% de tu inversión. Así de fácil.
            </h6>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              🔐 Aprende sin miedo. Invierte sin riesgo.
            </h6>
            <h6 style={{ color: 'white', fontSize: '1.125rem', marginTop: '1rem', textAlign: 'justify' }}>
              🔥 Cientos de alumnos ya comenzaron… ¿y tú?
            </h6>
          </div>
          <div className="garantia-img">
            <img
              src={logogarantia}
              alt="Sello 7 días de garantía"
              style={{ width: '100%', maxWidth: '300px', height: 'auto' }}
            />
          </div>
        </div>
      </section>

      {/* OTRA INFORMACIÓN RELEVANTE DEL CURSO Y DETALLE DEL COSTO */}
      <section className="py-16 sm:py-24 bg-black/20">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>⏳ DURACIÓN</h2>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            {course.duration}
          </div>
          <br></br>
          <h2 style={{ fontSize: '1.6rem', fontWeight: 'bold', marginBottom: '2rem', color: 'white' }}>💻 MODALIDAD</h2>
          <div style={{ maxWidth: '600px', margin: '0 auto' }}>
            {course.mode}
          </div>
        </div>
      </section>

      <section className="content-wrapper" style={{ backgroundColor: '#0f172a', padding: '3rem 1rem', textAlign: 'center' }}>
        <div className="center-flex text-center">
          <h2 className="mt-4" style={{ color: 'white' }}>¿Aún tienes dudas? ¡Contáctanos al WhatsApp!</h2>
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="whatsapp-button" onClick={() => trackMetaEvent('Lead', { content_name: course.title, content_ids: [course.id] })}>
            <img
              src={imgWhatsApp}
              alt="WhatsApp Icon"
              className="whatsapp-icon"
            />
            Click en este botón
          </a>
        </div>
         <p className="text-slate-300 mt-4"><h1>Transformando futuros a través de la educación</h1></p>
      </section>
      <WhatsAppButton course={course}/>
      {/* Modal de Inscripción */}
      <InscriptionModal show={showModal} handleClose={handleCloseModal} course={course} newPrice={price.priceFormat} currency={price.currency} country={country} />
    </div>


  );
};

export default CourseDetail;
